import RegistrationStepFour from '@/components/registration/steps/RegistrationStepFour';
import RegistrationStepOne from '@/components/registration/steps/RegistrationStepOne';


//early birds share the same fields basically as the registration page. only caveats are in step 1 and step 4 where there is no staff,CAP,board, checks, 
// and in step 4 the payment options are limited to credit card only. 

const EarlyBirdRegistrationSteps = [
    {
        label: 'Registration Confirmation',
        Inputs: () => <RegistrationStepOne earlyBird={true} />
    },
    { 
        label: 'Payment',
        Inputs: () => <RegistrationStepFour isEarlyBird={true} />
    }
];


export default EarlyBirdRegistrationSteps;